import { FC } from 'react';
import { Skeleton } from 'ui/skeleton';
import styled from 'styled-components';
import { spacing } from 'ui/theme';

const DynamicSkeleton = styled(Skeleton)`
  width: 100%;
  max-height: 100%;
  overflow: hidden;
`;

const MainRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${spacing.plusHalf};
  width: 100%;
`;

const LeftSkeleton = styled(DynamicSkeleton)`
  width: 75%;
`;

const RightSkeleton = styled(DynamicSkeleton)`
  width: 35%;
`;

export const STOTrendsSkeleton: FC = () => {
  return (
    <MainRow>
      <LeftSkeleton height={400} />
      <RightSkeleton height={400} />
    </MainRow>
  );
};
